import React, { useState, useEffect } from "react";
import DashHeader from "../../../components/dashHeader/DashHeader";
import { API } from "../../../config/config";
import { formatDate } from "../../../utils/formatDate";
import {
  ResComplaintData,
  ResLuggageData,
  ResDataVisitingRequests,
} from "../../../types/types";
import { AppDispatch, RootState } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchVisitorRequests,
  updateVisitorRequestStatus,
} from "../../../redux/slices/visitorSlice";
import {
  fetchLuggageRequests,
  updateLuggageRequestStatus,
} from "../../../redux/slices/luggageSlice";
import {
  fetchComplaints,
  updateComplaintStatus,
} from "../../../redux/slices/complaintsSlice";
import { Card } from "@/components/ui/card";
import { SetTable } from "@/components/SetTable";
import { routeNames } from "constants/constants";
import { useLocation, useNavigate } from "react-router-dom";

const Management: React.FC = () => {
  const location = useLocation();
  const { buildingId } = location.state || {};
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState("Luggage Requests");
  const dispatch = useDispatch<AppDispatch>();
  const { complaints, loading: complaintsLoading } = useSelector(
    (state: RootState) => state.complaints
  );
  // const filterComplaints = complaints?.filter((complaint: any) => complaint?.filedBy?.building === buildingId);
  // useEffect(() => {
  //   switch (selectedTab) {
  //     case "Luggage Requests":
  //       dispatch(fetchLuggageRequests());
  //       break;
  //     case "Visitor Requests":
  //       dispatch(fetchVisitorRequests());
  //       break;
  //     case "Complaints":
  //       dispatch(fetchComplaints());
  //       break;
  //     default:
  //       break;
  //   }
  // }, [dispatch, selectedTab]);

  useEffect(() => {
    // dispatch(fetchLuggageRequests());
    // dispatch(fetchVisitorRequests());
    dispatch(fetchComplaints(buildingId));
  }, [dispatch]);

  // const { luggageRequests, loading: luggageLoading } = useSelector(
  //   (state: RootState) => state.luggage
  // );

  // const { visitorRequests, loading: visitorLoading } = useSelector(
  //   (state: RootState) => state.visitor
  // );
  // const handleLuggageStatusUpdate = (requestId: string, newStatus: string) => {
  //   dispatch(updateLuggageRequestStatus({ requestId, status: newStatus }));
  // };

  // const handleVisitorStatusUpdate = (requestId: string, newStatus: string) => {
  //   dispatch(updateVisitorRequestStatus({ requestId, status: newStatus }));
  // };

  const handleComplaintStatusUpdate = (
    complaintId: string,
    newStatus: string
  ) => {
    dispatch(updateComplaintStatus({ complaintId, status: newStatus }));
  };
  const handleManagementDetail = (item: any) => {
    navigate(`${routeNames.managementDetail}/${item._id}`, {
      state: { item },
    });
  };
  const complaintstableKeys = [
    {
      title: "title",
    },
    {
      ID: "complaintId",
    },
    {
      Name: "filedBy.name",
    },
    {
      flatNo: "filedBy.flatNo",
    },
  ];
  const actions = [
    {
      label: "In_Progress",

      handler: (row: any) => handleComplaintStatusUpdate(row._id, "In_Progress"),
    },
    {
      label: "Resolved",

      handler: (row: any) => handleComplaintStatusUpdate(row._id, "Resolved"),
    },
    {
      label: "Details",
      handler: (row: any) => handleManagementDetail(row),
    },

  ];
  return (
    <>
      <DashHeader title="Maintenance" />
      <div className="p-3">
        <div className="flex gap-6 border-b-2 mb-6">
          {["Complaints"].map((tab) => (
            <button
              key={tab}
              className={`px-6 py-2 font-medium ${selectedTab === tab
                ? "border-b-4 border-blue-500 text-blue-500"
                : "text-gray-600"
                } hover:text-blue-500 transition`}
              onClick={() => setSelectedTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
        {/* {selectedTab === "Luggage Requests" && luggageLoading ? (
          <div className="flex justify-center items-center h-32 mt-12">
            <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid border-b-transparent"></div>
          </div>
        ) : (
          selectedTab === "Luggage Requests" && (
            <>
              <h2 className="text-xl font-bold mr-auto mb-6">
                Luggage Requests:
              </h2>
              {luggageRequests.length > 0 ? (
                luggageRequests.map((request: ResLuggageData) => (
                  <div
                    className="bg-white text-sm my-2 cursor-pointer border border-gray-200 rounded-lg shadow-lg p-6 w-full hover:shadow-2xl transition duration-200"
                    key={request?._id}
                  >
                    <h3 className="text-lg font-semibold text-gray-800">
                      {request?.description}
                    </h3>
                    <div className="flex justify-between">
                      <p className="mt-2 text-gray-600">
                        <strong>Tenant:</strong> {request?.tenant?.name} (
                        {request?.tenant?.email})
                      </p>
                      <div className="flex gap-6">
                        <p className="mt-2 text-gray-600">
                          <strong>Move Type:</strong> {request?.moveType}
                        </p>
                        <p className="mt-2 text-gray-600">
                          <strong>Status:</strong> {request?.status}
                        </p>
                      </div>
                    </div>
                    <div className="flex justify-between items-end">
                      <div className="flex gap-6">
                        <p className="mt-2 text-gray-600">
                          <strong>Date:</strong> {formatDate(request.date)}
                        </p>
                        <p className="mt-2 text-gray-600">
                          <strong>Time:</strong> {request?.time}
                        </p>
                      </div>
                      <div className="flex gap-4 mt-1">
                        {request?.status === "Pending" && (
                          <>
                            <button
                              className="px-4 py-1.5 bg-green-500 text-white rounded-lg hover:bg-green-600 transition duration-200"
                              onClick={() =>
                                handleLuggageStatusUpdate(
                                  request?._id,
                                  "Approved"
                                )
                              }
                            >
                              Approve
                            </button>
                            <button
                              className="px-4 py-1.5 bg-red-500 text-white rounded-lg hover:bg-red-600 transition duration-200"
                              onClick={() =>
                                handleLuggageStatusUpdate(request?._id, "Denied")
                              }
                            >
                              Deny
                            </button>
                          </>
                        )}
                        {request?.status === "Approved" && (
                          <button
                            className="px-4 py-1.5 bg-red-500 text-white rounded-lg hover:bg-red-600 transition duration-200"
                            onClick={() =>
                              handleLuggageStatusUpdate(request?._id, "Denied")
                            }
                          >
                            Deny
                          </button>
                        )}
                        {request?.status === "Denied" && (
                          <button
                            className="px-4 py-1.5 bg-green-500 text-white rounded-lg hover:bg-green-600 transition duration-200"
                            onClick={() =>
                              handleLuggageStatusUpdate(request?._id, "Approved")
                            }
                          >
                            Approve
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-center text-gray-600 w-full">
                  No requests found.
                </p>
              )}
            </>
          )
        )} */}

        {selectedTab === "Complaints" && complaintsLoading ? (
          <div className="flex justify-center items-center h-32 mt-12">
            <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid border-b-transparent"></div>
          </div>
        ) : (
          // selectedTab === "Complaints" && (
          //   <>
          //     <h2 className="text-xl font-bold mr-auto mt-12 mb-6">
          //       Complaint Requests:
          //     </h2>
          //     {complaints.length > 0 ? (
          //       complaints.map((complaint: ResComplaintData) => (
          //         <div
          //           className="bg-white text-sm my-2 cursor-pointer border border-gray-200 rounded-lg shadow-lg p-6 w-full hover:shadow-2xl transition duration-200"
          //           key={complaint?._id}
          //         >
          //           <div className="flex justify-between">
          //             <h3 className="text-lg font-semibold text-gray-800">
          //               {complaint?.title}
          //             </h3>
          //             <p className="mt-2 text-gray-600">
          //               <strong>Complaint ID:</strong> {complaint?.complaintId}
          //             </p>
          //           </div>
          //           <div className="flex justify-between">
          //             <p className="mt-2 text-gray-600">
          //               <strong>Description:</strong> {complaint?.description}
          //             </p>
          //             <p className="mt-2 text-gray-600">
          //               <strong>Status:</strong> {complaint?.status}
          //             </p>
          //           </div>
          //           <div className="flex justify-between">
          //             <p className="mt-2 text-gray-600">
          //               <strong>Filed By:</strong> {complaint?.filedBy?.name} (
          //               {complaint?.filedBy?.email})
          //             </p>
          //             <p className="mt-2 text-gray-600">
          //               <strong>Created At:</strong>{" "}
          //               {formatDate(complaint?.createdAt)}
          //             </p>
          //           </div>
          //           <div className="flex justify-between">
          //             {complaint?.photos?.length > 0 && (
          //               <div className="mt-3 flex gap-3 items-center">
          //                 <div className="flex gap-4 mt-2">
          //                   {complaint?.photos.map(
          //                     (photo: any, index: number) => (
          //                       <img
          //                         key={index}
          //                         src={Base_url + "/" + photo}
          //                         alt={`Complaint Photo ${index + 1}`}
          //                         className="h-14 w-28 object-cover rounded-md"
          //                       />
          //                     )
          //                   )}
          //                 </div>
          //               </div>
          //             )}
          //             <div className="flex items-end">
          //               <div className="flex gap-2.5">
          //                 {complaint?.status === "Pending" && (
          //                   <>
          //                     <button
          //                       className="px-4 py-1.5 bg-green-500 text-white rounded-lg hover:bg-green-600 transition duration-200"
          //                       onClick={() =>
          //                         handleComplaintStatusUpdate(
          //                           complaint?._id,
          //                           "In_Progress"
          //                         )
          //                       }
          //                     >
          //                       Start Progress
          //                     </button>
          //                     <button
          //                       className="px-4 py-1.5 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition duration-200"
          //                       onClick={() =>
          //                         handleComplaintStatusUpdate(
          //                           complaint?._id,
          //                           "Resolved"
          //                         )
          //                       }
          //                     >
          //                       Resolve
          //                     </button>
          //                   </>
          //                 )}
          //                 {complaint?.status === "In_Progress" && (
          //                   <button
          //                     className="px-4 py-1.5 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition duration-200"
          //                     onClick={() =>
          //                       handleComplaintStatusUpdate(
          //                         complaint?._id,
          //                         "Resolved"
          //                       )
          //                     }
          //                   >
          //                     Resolve
          //                   </button>
          //                 )}
          //                 {complaint?.status === "Resolved" && (
          //                   <button
          //                     className="px-4 py-1.5 bg-red-500 text-white rounded-lg hover:bg-red-600 transition duration-200"
          //                     onClick={() =>
          //                       handleComplaintStatusUpdate(
          //                         complaint?._id,
          //                         "In_Progress"
          //                       )
          //                     }
          //                   >
          //                     Reopen
          //                   </button>
          //                 )}
          //               </div>
          //             </div>
          //           </div>
          //         </div>
          //       ))
          //     ) : (
          //       <p className="text-center text-gray-600 w-full">
          //         No complaints found.
          //       </p>
          //     )}
          //   </>
          // )
          <Card className="p-5 col-span-7">
            <div className="flex items-center justify-between">
              <h2 className="text-xl font-bold mr-auto mt-12 mb-6">
                Complaint Requests:
              </h2>
            </div>
            <SetTable data={complaints} tableKeys={complaintstableKeys} actions={actions} />
          </Card>
        )}

        {/* {selectedTab === "Visitor Requests" && visitorLoading ? (
          <div className="flex justify-center items-center h-32 mt-12">
            <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid border-b-transparent"></div>
          </div>
        ) : (
          selectedTab === "Visitor Requests" && (
            <>
              <h2 className="text-xl font-bold mr-auto mt-12 mb-6">
                Visitor Requests:
              </h2>
              {visitorRequests.length > 0 ? (
                visitorRequests.map((request: ResDataVisitingRequests) => (
                  <div
                    className="bg-white text-sm my-2 cursor-pointer border border-gray-200 rounded-lg shadow-lg p-6 w-full hover:shadow-2xl transition duration-200"
                    key={request?._id}
                  >
                    <div className="flex justify-between">
                      <h3 className="text-lg font-medium text-gray-800">
                        <strong>Building:</strong> {request?.building?.name}{" "}
                        <strong>Flat Number:</strong> {request?.flatNumber}
                      </h3>
                      <p className="mt-2 text-gray-600">
                        <strong>Visitor Name:</strong> {request?.name}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="mt-2 text-gray-600">
                        <strong>Contact Number:</strong> {request?.contactNumber}
                      </p>
                      <p className="mt-2 text-gray-600">
                        <strong>Email:</strong> {request?.email || "N/A"}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="mt-2 text-gray-600">
                        <strong>Expected Arrival:</strong>{" "}
                        {formatDate(request?.expectedArrivalTime)}
                      </p>
                      <p className="mt-2 text-gray-600">
                        <strong>Visitor Type:</strong> {request?.visitorType}
                      </p>
                    </div>
                    {request?.visitorType === "Commercial" && (
                      <div className="mt-2 text-gray-600">
                        <strong>Company Name:</strong>{" "}
                        {request?.companyName || "N/A"}
                      </div>
                    )}
                    <div className="">
                      {request?.requestedBy && (
                        <p className="mt-2 text-gray-600">
                          <strong>Requested By:</strong>{" "}
                          {request?.requestedBy.name} (
                          {request?.requestedBy.email})
                        </p>
                      )}
                      <div className="flex justify-between items-end">
                        <p className="mt-2 text-gray-600">
                          <strong>Status:</strong> {request?.status}
                        </p>
                        <div className="mt-3 flex gap-2.5">
                          {request?.status === "Pending" && (
                            <>
                              <button
                                className="px-4 py-1.5 bg-green-500 text-white rounded-lg hover:bg-green-600 transition duration-200"
                                onClick={() =>
                                  handleVisitorStatusUpdate(
                                    request?._id,
                                    "Approved"
                                  )
                                }
                              >
                                Approve
                              </button>
                              <button
                                className="px-4 py-1.5 bg-red-500 text-white rounded-lg hover:bg-red-600 transition duration-200"
                                onClick={() =>
                                  handleVisitorStatusUpdate(
                                    request?._id,
                                    "Denied"
                                  )
                                }
                              >
                                Deny
                              </button>
                            </>
                          )}
                          {request?.status === "Approved" && (
                            <button
                              className="px-4 py-1.5 bg-red-500 text-white rounded-lg hover:bg-red-600 transition duration-200"
                              onClick={() =>
                                handleVisitorStatusUpdate(request?._id, "Denied")
                              }
                            >
                              Deny
                            </button>
                          )}
                          {request?.status === "Denied" && (
                            <button
                              className="px-4 py-1.5 bg-green-500 text-white rounded-lg hover:bg-green-600 transition duration-200"
                              onClick={() =>
                                handleVisitorStatusUpdate(
                                  request?._id,
                                  "Approved"
                                )
                              }
                            >
                              Approve
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-center text-gray-600 w-full">
                  No visitor requests found.
                </p>
              )}
            </>
          )
        )} */}
      </div>
    </>
  );
};

export default Management;
